const QCActivityActionTypes = {
	CLEAR_ERROR: "CLEAR_ERROR",
	// Fetch QC
	FETCH_QC_START: "FETCH_QC_START",
	FETCH_QC_SUCCESS: "FETCH_QC_SUCCESS",
	FETCH_QC_FAILURE: "FETCH_QC_FAILURE",
};

export default QCActivityActionTypes;
